import { Component, OnInit, Input } from "@angular/core";
import { LayoutService } from "../../../services/layout.service";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { RoleAuthGuard } from "@app/core/guards/role_guard/role-auth.guard";
declare var $: any;

@Component({
  selector: "crm-menu-item",
  templateUrl: "./menu-item.component.html",
  styleUrls: ["./menu-item.component.scss"],
})
export class MenuItemComponent implements OnInit {
  @Input() navItems;
  expanded: boolean;
  term: any;
  currentUserId: any;
  type_id: any;

  constructor(
    private layoutService: LayoutService,
    private localStorageService: LocalStorageService,
    private auth:RoleAuthGuard
  ) { }

  ngOnInit() {
    const response = this.localStorageService.getLocalStorageItem("response");
    this.type_id = response.data.type_id
    if (response && response.data && response.data.user) {
      this.currentUserId = response.data.user.user_id;
    }
    $(document).ready(() => {
      const trees: any = $('[data-widget="tree"]');
      if (trees) {
        trees.tree();
      }
    });
  }

  // This function is requred if the menu items have children items
  // setExpandedTrue(event) {
  //   if ((event.target.value! = "")) {
  //     this.expanded = true;
  //   } else {
  //     this.expanded = false;
  //   }
  // }

  setTitle(title) {
    this.layoutService.setContentTitle(title);
  }
  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
